import { View } from 'react-native'
import styled from 'styled-components'
import { media } from '../../style/media'

export const ListContainer = styled(View)`
  width: ${(props) => props.theme.width}px;
  margin-bottom: ${(props) => props.theme.spacing.smedium}px;
  ${media.sm`
    margin-bottom: ${(props) => props.theme.spacing.medium}px;
  `};
  ${media.md`
    margin-bottom: ${(props) => props.theme.spacing.large}px;
  `};
`
